import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { TOOL_LABELS } from '../utils/annotationClipboardCopy';

const buttonSx = {
  width: 48,
  height: 38,
  p: 0,
  color: '#30343a',
  borderColor: '#aeb3ba !important',
  backgroundColor: '#fff',
  transition: 'background-color 140ms ease, color 140ms ease, box-shadow 140ms ease',
  '&:hover': { backgroundColor: '#eef0f2', color: '#111' },
  '&.Mui-selected': {
    color: '#fff',
    backgroundColor: '#17191c',
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.08)',
    '&:hover': { backgroundColor: '#090a0b' },
  },
  '&.Mui-focusVisible': { outline: '3px solid #4f7edb', outlineOffset: 2 },
};

const AnnotationToolToggle = ({ mode, onChange, disabled = false }) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={mode}
    disabled={disabled}
    onChange={(_, nextMode) => {
      if (nextMode) onChange(nextMode);
    }}
    aria-label="Annotation editing tool (标注编辑工具)"
    sx={{
      backgroundColor: '#fff',
      borderRadius: '9px',
      boxShadow: '0 2px 7px rgba(0,0,0,.24)',
      '& .MuiToggleButtonGroup-grouped': { m: 0 },
    }}
  >
    <ToggleButton value="cursor" aria-label={TOOL_LABELS.cursor} title={TOOL_LABELS.cursor} sx={buttonSx}>
      <NearMeOutlinedIcon fontSize="small" sx={{ transform: 'rotate(-12deg)' }} />
    </ToggleButton>
    <ToggleButton value="pencil" aria-label={TOOL_LABELS.pencil} title={TOOL_LABELS.pencil} sx={buttonSx}>
      <EditOutlinedIcon fontSize="small" />
    </ToggleButton>
  </ToggleButtonGroup>
);

export default AnnotationToolToggle;
